import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '~/Services/api';
import Loading from '~/Components/Loading';
import format from '~/Utils/format';

function copiarTexto(texto) {
  const valor = String(texto || '').trim();
  if (!valor) return;
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(valor)
      .then(() => toast.success('Copiado'))
      .catch(() => fallbackCopy(valor));
    return;
  }
  fallbackCopy(valor);
}

function fallbackCopy(valor) {
  const ta = document.createElement('textarea');
  ta.value = valor;
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
    toast.success('Copiado');
  } finally {
    document.body.removeChild(ta);
  }
}

function montarTextoCopia(resumo) {
  if (!resumo) return '';
  const linhas = [];

  if (resumo.tipo_acordo) {
    linhas.push(`TIPO DE RESCISÃO: ${resumo.tipo_acordo}`);
    linhas.push('');
  }

  const id = resumo.identificacao;
  linhas.push('Lançamento de Despesas - Rescisão Contratual');
  linhas.push(`Nome do Cliente: ${id.nome_cliente}`);
  linhas.push(
    `GE: ${id.codigo_grupo_empresa}    Código Cliente: ${id.codigo_cliente}`
  );
  linhas.push(`Empreendimento: ${id.empreendimento}`);
  linhas.push(`Quadra/Lote: ${id.quadra_lote}`);
  if (id.data_compra) linhas.push(`Data da Compra: ${format.date(id.data_compra)}`);
  linhas.push(`Status do Contrato: ${id.status_contrato}`);
  linhas.push(`Motivo: ${id.motivo}`);
  if (id.numero_processo) linhas.push(`Nº do Processo: ${id.numero_processo}`);

  if (resumo.juridico) {
    linhas.push('');
    linhas.push('');
    if (resumo.juridico.instancias_percorridas)
      linhas.push(
        `Instâncias Judiciais/Adm. Percorridas: ${resumo.juridico.instancias_percorridas}`
      );
    if (resumo.juridico.desfecho_processual)
      linhas.push(`Desfecho Processual: ${resumo.juridico.desfecho_processual}`);
    if (resumo.juridico.observacoes)
      linhas.push(`Observações: ${resumo.juridico.observacoes}`);
  }

  const vo = resumo.valores_originais;
  linhas.push('');
  linhas.push('');
  linhas.push(
    `Pagamentos lançados até  ${format.date(vo.data_pagamentos_lancados_ate)}: ${format.money(vo.pagamentos_lancados_ate)}`
  );
  linhas.push(`Valor de Quitação: ${format.money(vo.valor_quitacao)}`);
  linhas.push(
    `Valor de Mercado(${format.date(vo.data_valor_mercado)}): ${format.money(vo.valor_mercado_data)}`
  );
  linhas.push(`Valor de Mercado(Hoje): ${format.money(vo.valor_mercado_hoje)}`);

  const vc = resumo.valores_cliente;
  linhas.push('');
  linhas.push('');
  linhas.push(`Valor Pago Cliente Atual: ${format.money(vc.valor_pago_cliente_atual)}`);
  linhas.push(
    `Valor Pago Cliente Anterior: ${format.money(vc.valor_pago_cliente_anterior)}`
  );
  if (vc.nome_empresa_anterior)
    linhas.push(
      `Recebimento ${vc.nome_empresa_anterior}: ${format.money(vc.recebimento_empresa_anterior)}`
    );
  linhas.push(`Recebimento Setpar: ${format.money(vc.recebimento_setpar)}`);
  linhas.push(`Valor Total Pago: ${format.money(vc.valor_total_pago)}`);
  linhas.push(`Valor Pago Atualizado: ${format.money(vc.valor_pago_atualizado)}`);

  if (resumo.encargos) {
    const e = resumo.encargos;
    linhas.push('');
    linhas.push('');
    if (e.iptu) linhas.push(`Valor de IPTU: ${format.money(e.iptu)}`);
    if (e.agua) linhas.push(`Valor de Água: ${format.money(e.agua)}`);
    if (e.calcada) linhas.push(`Valor de Calçada: ${format.money(e.calcada)}`);
    if (e.condominio)
      linhas.push(`Valor de Condomínio: ${format.money(e.condominio)}`);
    if (e.energia) linhas.push(`Valor de Energia: ${format.money(e.energia)}`);
    if (e.limpeza) linhas.push(`Valor de Limpeza: ${format.money(e.limpeza)}`);
  }

  const a = resumo.acordo;
  linhas.push('');
  linhas.push('');
  linhas.push(`${a.titulo_valor_total}: ${format.money(a.valor_total)}`);
  linhas.push(
    `Referente as Parcelas Pagas/Reembolso: ${format.money(a.referente_parcelas_pagas_reembolso)}`
  );
  linhas.push(`Quantidade de parcelas: ${a.quantidade_parcelas}`);
  if (a.quantidade_parcelas_sucumbenciais > 0) {
    linhas.push(
      `Referente aos Honorários Sucumbênciais: ${format.money(a.honorarios_sucumbenciais)}`
    );
    linhas.push(`Quantidade de parcelas: ${a.quantidade_parcelas_sucumbenciais}`);
  }
  if (a.fruicao) {
    linhas.push(`Fruição: ${a.fruicao}`);
    linhas.push(`Multa Inversa: ${a.multa_inversa || ''}`);
    linhas.push(`Danos Morais: ${a.danos_morais || ''}`);
    linhas.push(`Indenização Edificação: ${a.indenizacao_edificacao || ''}`);
    linhas.push(`Custas Processuais: ${format.money(a.custas_processuais)}`);
  }

  return linhas.join('\n');
}

const Linha = ({ label, valor }) => (
  <div className="d-flex justify-content-between align-items-baseline mb-1">
    <small className="text-muted mr-2">{label}</small>
    <span className="text-right">{valor}</span>
  </div>
);

const Bloco = ({ titulo, children }) => (
  <div className="mb-3">
    {titulo && <h6 className="text-primary mb-2">{titulo}</h6>}
    {children}
    <hr className="my-2" />
  </div>
);

function ResumoPagamentoTemplate({ chave }) {
  const [resumo, setResumo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    let cancelado = false;
    setLoading(true);
    setErro(null);
    api
      .buscarResumoPagamento(chave.codigo)
      .then(dados => {
        if (!cancelado) setResumo(dados);
      })
      .catch(e => {
        if (!cancelado) setErro(e && e.Message ? e.Message : 'Falha ao carregar o resumo');
      })
      .finally(() => {
        if (!cancelado) setLoading(false);
      });
    return () => {
      cancelado = true;
    };
  }, [chave.codigo]);

  if (loading) return <Loading />;
  if (erro) return <p className="text-danger">{erro}</p>;
  if (!resumo) return <p>Sem dados para esta chave.</p>;

  const id = resumo.identificacao;
  const vo = resumo.valores_originais;
  const vc = resumo.valores_cliente;
  const a = resumo.acordo;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <strong>Chave: {resumo.chave}</strong>
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() => copiarTexto(montarTextoCopia(resumo))}
        >
          Copiar
        </Button>
      </div>

      {resumo.tipo_acordo && (
        <Bloco>
          <strong>TIPO DE RESCISÃO:</strong> {resumo.tipo_acordo}
        </Bloco>
      )}

      <Bloco titulo="Identificação">
        <div className="mb-1">Lançamento de Despesas - Rescisão Contratual</div>
        <Linha label="Nome do Cliente" valor={id.nome_cliente} />
        <Linha
          label="GE / Código Cliente"
          valor={`${id.codigo_grupo_empresa} / ${id.codigo_cliente}`}
        />
        <Linha label="Empreendimento" valor={id.empreendimento} />
        <Linha label="Quadra/Lote" valor={id.quadra_lote} />
        {id.data_compra && (
          <Linha label="Data da Compra" valor={format.date(id.data_compra)} />
        )}
        <Linha label="Status do Contrato" valor={id.status_contrato} />
        <Linha label="Motivo" valor={id.motivo} />
        {id.numero_processo && (
          <Linha label="Nº do Processo" valor={id.numero_processo} />
        )}
      </Bloco>

      {resumo.juridico && (
        <Bloco titulo="Dados Jurídicos">
          {resumo.juridico.instancias_percorridas && (
            <Linha
              label="Instâncias Judiciais/Adm. Percorridas"
              valor={resumo.juridico.instancias_percorridas}
            />
          )}
          {resumo.juridico.desfecho_processual && (
            <Linha
              label="Desfecho Processual"
              valor={resumo.juridico.desfecho_processual}
            />
          )}
          {resumo.juridico.observacoes && (
            <Linha label="Observações" valor={resumo.juridico.observacoes} />
          )}
        </Bloco>
      )}

      <Bloco titulo="Valores Originais">
        <Linha
          label={`Pagamentos lançados até ${format.date(vo.data_pagamentos_lancados_ate)}`}
          valor={format.money(vo.pagamentos_lancados_ate)}
        />
        <Linha label="Valor de Quitação" valor={format.money(vo.valor_quitacao)} />
        <Linha
          label={`Valor de Mercado (${format.date(vo.data_valor_mercado)})`}
          valor={format.money(vo.valor_mercado_data)}
        />
        <Linha
          label="Valor de Mercado (Hoje)"
          valor={format.money(vo.valor_mercado_hoje)}
        />
      </Bloco>

      <Bloco titulo="Valores do Cliente">
        <Linha
          label="Valor Pago Cliente Atual"
          valor={format.money(vc.valor_pago_cliente_atual)}
        />
        <Linha
          label="Valor Pago Cliente Anterior"
          valor={format.money(vc.valor_pago_cliente_anterior)}
        />
        {vc.nome_empresa_anterior && (
          <Linha
            label={`Recebimento ${vc.nome_empresa_anterior}`}
            valor={format.money(vc.recebimento_empresa_anterior)}
          />
        )}
        <Linha
          label="Recebimento Setpar"
          valor={format.money(vc.recebimento_setpar)}
        />
        <Linha label="Valor Total Pago" valor={format.money(vc.valor_total_pago)} />
        <Linha
          label="Valor Pago Atualizado"
          valor={format.money(vc.valor_pago_atualizado)}
        />
      </Bloco>

      {resumo.encargos && (
        <Bloco titulo="Encargos">
          {resumo.encargos.iptu !== 0 && (
            <Linha label="Valor de IPTU" valor={format.money(resumo.encargos.iptu)} />
          )}
          {resumo.encargos.agua !== 0 && (
            <Linha label="Valor de Água" valor={format.money(resumo.encargos.agua)} />
          )}
          {resumo.encargos.calcada !== 0 && (
            <Linha
              label="Valor de Calçada"
              valor={format.money(resumo.encargos.calcada)}
            />
          )}
          {resumo.encargos.condominio !== 0 && (
            <Linha
              label="Valor de Condomínio"
              valor={format.money(resumo.encargos.condominio)}
            />
          )}
          {resumo.encargos.energia !== 0 && (
            <Linha
              label="Valor de Energia"
              valor={format.money(resumo.encargos.energia)}
            />
          )}
          {resumo.encargos.limpeza !== 0 && (
            <Linha
              label="Valor de Limpeza"
              valor={format.money(resumo.encargos.limpeza)}
            />
          )}
        </Bloco>
      )}

      <Bloco titulo="Acordo / Condenação">
        <Linha label={a.titulo_valor_total} valor={format.money(a.valor_total)} />
        <Linha
          label="Referente as Parcelas Pagas/Reembolso"
          valor={format.money(a.referente_parcelas_pagas_reembolso)}
        />
        <Linha label="Quantidade de parcelas" valor={a.quantidade_parcelas} />
        {a.quantidade_parcelas_sucumbenciais > 0 && (
          <>
            <Linha
              label="Referente aos Honorários Sucumbênciais"
              valor={format.money(a.honorarios_sucumbenciais)}
            />
            <Linha
              label="Quantidade de parcelas (Sucumbenciais)"
              valor={a.quantidade_parcelas_sucumbenciais}
            />
          </>
        )}
        {a.fruicao && (
          <>
            <Linha label="Fruição" valor={a.fruicao} />
            {a.multa_inversa && <Linha label="Multa Inversa" valor={a.multa_inversa} />}
            {a.danos_morais && <Linha label="Danos Morais" valor={a.danos_morais} />}
            <Linha
              label="Indenização Edificação"
              valor={a.indenizacao_edificacao}
            />
            <Linha
              label="Custas Processuais"
              valor={format.money(a.custas_processuais)}
            />
          </>
        )}
      </Bloco>
    </div>
  );
}

export default ResumoPagamentoTemplate;
